import { render, staticRenderFns } from "./activeContent.vue?vue&type=template&id=f018a804&scoped=true"
import script from "./activeContent.vue?vue&type=script&lang=js"
export * from "./activeContent.vue?vue&type=script&lang=js"
import style0 from "./activeContent.vue?vue&type=style&index=0&id=f018a804&prod&lang=scss&scoped=true"
import style1 from "./activeContent.vue?vue&type=style&index=1&id=f018a804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f018a804",
  null
  
)

export default component.exports